import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';

interface BannerSkeletonProps {
  children: ReactNode;
  className?: string;
}

const BannerSkeleton: FC<BannerSkeletonProps> = ({ children, className }) => {
  return (
    <div
      className={classNames(
        'alert warning-alert w-full bg-banner-yellow h-[50px] !text-unique-800 font-normal font-sans text-center pl-24 pr-3 py-3 relative flex items-center justify-center',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default BannerSkeleton;
